import { useMemo } from 'react';
import PropTypes from 'prop-types';

import { ROUTES } from '#/config/routes';
import useDetailTable from '#/hooks/table/useDetailTable';
import DetailTable from '#/modules/commonComponents/table/DetailTable';
import MaterialNameStack from '#/modules/imsMgmt/receipts/shared/MaterialNameStack';
import { compareMtrNo } from '#/modules/momMgmt/workOrder/helper/compareMtrNo';

function resolveGroupMaterial(row) {
  const mtr = row?.sourceGroupMtr;
  return {
    name: mtr?.name ?? '',
    mtrNo: mtr?.mtrNo ?? '',
    id: mtr?.id ?? row?.sourceGroupMaterialId ?? '',
  };
}

function resolveSelectedMaterial(row) {
  const mtr = row?.selectedMtr;
  return {
    name: mtr?.name ?? '',
    mtrNo: mtr?.mtrNo ?? '',
    id: mtr?.id ?? row?.selectedMaterialId ?? '',
  };
}

const columns = [
  {
    id: 'groupMaterial',
    header: '群組料',
    accessorFn: (row) => {
      const mtr = resolveGroupMaterial(row);
      return [mtr.mtrNo, mtr.name].filter(Boolean).join(' ') || mtr.id || '—';
    },
    size: 220,
    enableSorting: false,
    meta: { cellClassName: 'td_left' },
    cell: ({ row }) => {
      const mtr = resolveGroupMaterial(row.original);
      return (
        <MaterialNameStack
          name={mtr.name}
          code={mtr.mtrNo}
          detailPath={mtr.id ? ROUTES.mtrDetail(mtr.id) : null}
        />
      );
    },
  },
  {
    id: 'selectedMaterial',
    header: '選定 NORMAL',
    accessorFn: (row) => {
      const mtr = resolveSelectedMaterial(row);
      return [mtr.mtrNo, mtr.name].filter(Boolean).join(' ') || mtr.id || '—';
    },
    size: 220,
    enableSorting: false,
    meta: { cellClassName: 'td_left' },
    cell: ({ row }) => {
      const mtr = resolveSelectedMaterial(row.original);
      return (
        <MaterialNameStack
          name={mtr.name}
          code={mtr.mtrNo}
          detailPath={mtr.id ? ROUTES.mtrDetail(mtr.id) : null}
        />
      );
    },
  },
];

const WorkOrderBomSelectionsTable = ({ rows = [] }) => {
  const tableRows = useMemo(
    () => [...(rows ?? [])]
      .sort((left, right) => compareMtrNo(
        left?.sourceGroupMtr?.mtrNo,
        right?.sourceGroupMtr?.mtrNo,
      ))
      .map((row, index) => {
        const groupId = row?.sourceGroupMtr?.id ?? row?.sourceGroupMaterialId;
        return {
          ...row,
          id: groupId ? `${groupId}-${index}` : `selection-${index}`,
        };
      }),
    [rows],
  );

  const detailTableState = useDetailTable(tableRows, columns, {
    enableExpanding: false,
    getRowId: (row) => String(row.id),
  });

  if (tableRows.length === 0) {
    return <p className="px-4 py-5 text-sm text-muted-foreground">尚無資料</p>;
  }

  return (
    <div className="detail-table-container">
      <DetailTable
        state={detailTableState}
        containerClassName="detail-table-scroll--section-embedded"
        tableClassName="detail-table--flat-lines"
      />
    </div>
  );
};

WorkOrderBomSelectionsTable.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.object),
};

export default WorkOrderBomSelectionsTable;
